import React, { useState } from 'react'
import { Button } from 'primereact/button'

import useText from '../../../common/hooks/useText'
import { LogsTable, LOGS_NO_OF_ITEMS } from '../../../lib/logs-table'
import { CHARGE_POINT_REFRESH_TIMEOUT } from '../../../common/constants/ChargePointConstants'
import { WidgetLayout } from '../../../lib/widget-layout'
import { isMoreItemsToLoad } from '../../../lib/is-more-items-to-load'
import { useChargePointDataGetChargePointDataWithFilterQuery } from '../../../common/redux/api/web-api'
import { CapiLogFilters, CapiLogsFilterDialog } from '../dialogs/capi-logs-filter-dialog'

export type ChargepointChargerDataWidgetProps = {
    chargePointId: string
}

export interface IChargerDataLog {
    connectorId: string
    dataTypeDescription: string
    timestamp: string
    showData: boolean
    formattedData: string
}

export function ChargepointChargerDataWidget({ chargePointId }: ChargepointChargerDataWidgetProps): React.ReactElement {
    const text = useText()
    const [filters, setFilters] = useState<CapiLogFilters>({
        dataType: {
            WifiInfo: false,
            Temperature: false,
            ProcessorVoltage: false,
            PwmStateShifts: false,
            Pwm: false,
            GfcidcWaveform: false,
            ClientInfo: false,
        },
    })
    const [noOfItems, setNoOfItems] = useState(LOGS_NO_OF_ITEMS)

    const {
        data: logs = [],
        isLoading,
        isFetching,
    } = useChargePointDataGetChargePointDataWithFilterQuery(
        { chargePointId, noOfItems, dataLogFilter: filters },
        {
            pollingInterval: CHARGE_POINT_REFRESH_TIMEOUT,
        }
    )

    const [isFilterDialogVisible, setIsFilterDialogVisible] = useState(false)

    return (
        <WidgetLayout
            loadingStatus={isLoading}
            headerButtons={
                <Button
                    type="button"
                    icon="pi pi-filter"
                    size="small"
                    text
                    rounded
                    aria-label={text('btnFilterLogs')}
                    tooltip={text('btnFilterLogs')}
                    onClick={() => setIsFilterDialogVisible(!isFilterDialogVisible)}
                />
            }
            data-testid="chargerData"
        >
            <CapiLogsFilterDialog
                visible={isFilterDialogVisible}
                onHide={() => setIsFilterDialogVisible(false)}
                onApply={setFilters}
                filters={filters}
            />
            <LogsTable
                columns={[
                    {
                        label: text('lblConnectorShort'),
                        accessor: 'connectorId',
                        width: 50,
                    },
                    {
                        label: text('lblDataType'),
                        accessor: 'dataTypeDescription',
                        width: 150,
                    },
                    {
                        label: text('lblTimestamp'),
                        accessor: 'timestamp',
                        width: 100,
                    },
                    {
                        label: text('lblValue'),
                        accessor: 'formattedData',
                    },
                ]}
                logs={logs}
                actions={
                    isMoreItemsToLoad(noOfItems, logs.length)
                        ? [
                              {
                                  title: text('btnLoadMore'),
                                  onClick: () => {
                                      setNoOfItems((current) => current + logs.length)
                                  },
                              },
                          ]
                        : []
                }
                loading={isLoading || isFetching}
            />
        </WidgetLayout>
    )
}
